'use strict';
var React = require('react');
var assetsHelper = require('../../helper/assetsHelper');

var PaintToolbar = React.createClass({
  propTypes: {
    page: React.PropTypes.object.isRequired,
    onMouseClick: React.PropTypes.func.isRequired,
    onRectangleClick: React.PropTypes.func.isRequired,
    onFilledRectangleClick: React.PropTypes.func.isRequired,
    onEllipseClick: React.PropTypes.func.isRequired,
    onFilledEllipseClick : React.PropTypes.func.isRequired,
    onArrowClick: React.PropTypes.func.isRequired,
    onPencilClick: React.PropTypes.func.isRequired,
    onTextClick: React.PropTypes.func.isRequired,
    onSaveClick: React.PropTypes.func.isRequired,
    onUndoClick: React.PropTypes.func.isRequired,
    onRedoClick: React.PropTypes.func.isRequired,
    onDeleteClick: React.PropTypes.func.isRequired,
    onHiddenClick: React.PropTypes.func.isRequired,
    onClearClick: React.PropTypes.func.isRequired,
    onExitClick: React.PropTypes.func.isRequired,
    checkTool: React.PropTypes.string.isRequired,
    saveDisabled: React.PropTypes.bool.isRequired,
    redoDisabled: React.PropTypes.bool.isRequired,
    undoDisabled: React.PropTypes.bool.isRequired,
    isVisible: React.PropTypes.bool.isRequired,
    isClearable: React.PropTypes.bool.isRequired,
    onToolbarMountDone: React.PropTypes.func.isRequired,
  },
  getBoxStyle: function (tool) {
    if (tool === this.props.checkTool) {
      return {
        border: '1px solid #707070',
        borderRadius: '4px'
      };
    }
    return {};
  },

  location: null,
  getLocation: function() {
    var location = $('.tools-left').offset();
    if(location && (!this.location || location.left !== this.location.left || location.top !== this.location.top)) {
      this.location = location;
      this.props.onToolbarMountDone(location);
    }
  },
  componentDidMount: function() {
    this.getLocation();
  },

  componentDidUpdate: function() {
    this.getLocation();
  },

  render: function () {
    var page = this.props.page;
    var saveButtonStyle = {opacity:this.props.saveDisabled?0.5:1};
    var redoButtonStyle = {opacity:this.props.redoDisabled?0.5:1};
    var undoButtonStyle = {opacity:this.props.undoDisabled?0.5:1};
    var clearButtonStyle = {opacity:this.props.isClearable?1:0.5};
    var hiddenBackClass = '';
    if(this.props.isVisible) {
      hiddenBackClass = 'tool-background';
    }
    return (
      <div className="paint-toolbar">
        <h6 className="page-title">{page.title}</h6>
        <div className="tools">
          <div className="tools tools-left">

            <span style={this.getBoxStyle('RectTool')} onClick={this.props.onRectangleClick}>
              <img src={assetsHelper.getAsset('review/icon_empty_rect.png')}/>
            </span>
            <span style={this.getBoxStyle('FilledRectTool')} onClick={this.props.onFilledRectangleClick}>
              <img src={assetsHelper.getAsset('review/icon_filled_rect2.png')}/>
            </span>
            <span style={this.getBoxStyle('EllipseTool')} onClick={this.props.onEllipseClick}>
              <img src={assetsHelper.getAsset('review/icon_empty_ellipse.png')}/>
            </span>
            <span style={this.getBoxStyle('FilledEllipseTool')} onClick={this.props.onFilledEllipseClick}>
              <img src={assetsHelper.getAsset('review/icon_filled_ellipse2.png')}/>
            </span>
            <span style={this.getBoxStyle('ArrowTool')} onClick={this.props.onArrowClick}>
              <img src={assetsHelper.getAsset('review/icon_arrow.png')}/>
            </span>
            <span style={this.getBoxStyle('PencilTool')} onClick={this.props.onPencilClick}>
              <img src={assetsHelper.getAsset('review/icon_pencil.png')}/>
            </span>
            <span style={this.getBoxStyle('TextTool')} onClick={this.props.onTextClick}>
              <img src={assetsHelper.getAsset('review/icon_text.png')}/>
            </span>
          </div>
          <div className="tools tools-right">
            <span onClick={this.props.onSaveClick}>
              <img src={assetsHelper.getAsset('review/icon_save.png')} style={saveButtonStyle}/>
            </span>
            <span className={hiddenBackClass} onClick={this.props.onHiddenClick}>
              <img src={assetsHelper.getAsset('review/icon_hidden.png')}/>
            </span>
            <span onClick={this.props.onUndoClick}>
              <img src={assetsHelper.getAsset('review/icon_undo.png')} style={undoButtonStyle}/>
            </span>
            <span onClick={this.props.onRedoClick}>
              <img src={assetsHelper.getAsset('review/icon_redo.png')} style={redoButtonStyle}/>
            </span>
            <span onClick={this.props.onDeleteClick}>
              <img src={assetsHelper.getAsset('review/icon_delete.png')}/>
            </span>
            <span style={clearButtonStyle} onClick={this.props.onClearClick}>
              <img src={assetsHelper.getAsset('review/icon_clear.png')}/>
            </span>
          </div>
        </div>
        <img className="tool-exit" src={assetsHelper.getAsset('review/icon_close.png')}
             onClick={this.props.onExitClick}/>
      </div>
    )
  }
});

module.exports = PaintToolbar;


// WEBPACK FOOTER //
// ./src/views/Review/PaintToolbar.jsx